const data = {
  translation: {
    lbl_welcome: "Welcome to",
    lbl_hodo_community_events: "HODO Community Events",
    lbl_setup_sound_and_video:
      "Setting audio and screen device before participating.",
    lbl_join_room: "Join room",
    lbl_join_studio: "Join Studio",
    lbl_join_conference: "Join conference",
    lbl_enter_name: "Enter my name",
    lbl_on: "On",
    lbl_off: "Off",
    lbl_change_camera: "Toggle front or back Camera",
    lbl_add_virtual_background: "Add virtual background",
    lbl_vietnamese: "Vietnamese",
    lbl_english: "English",
    lbl_french: "French",
    gender: {
      male: "Male",
      female: "Female",
      unknown: "Unknown",
    },
    lbl_setting_device: "Device settings",
    lbl_notification: "Notification",
    lbl_view_layout: "Layout view",
    lbl_audio_device: "Audio device",
    lbl_speaker: "Speaker",
    lbl_test: "Test",
    lbl_noise_suppression: "Noise suppression",
    lbl_participants: "Participants",
    lbl_the_leaver: "The leaver",
    lbl_new_message: "New message",
    lbl_peer_joined: "Peer Joined",
    lbl_peer_leave: "Peer Leave",
    lbl_hand_raiser: "Hand-raiser",
    lbl_error: "Error",
    lbl_active_speaker_mode: "Active speaker mode",
    lbl_active_speaker_sorting: "Active Speaker Sorting",
    lbl_audio_only_mode: "Audio Only Mode",
    lbl_mirror_local_video: "Mirror Local Video",
    lbl_hide_local_video: "Hide Local Video",
    lbl_tiles_in_view: "Tiles In View",
    lbl_arranging_active_speakers: "Arranging active speakers",

    lbl_personal_video_mirror: "Mirror personal video",
    lbl_personal_video_hidden: "Hidden personal video",
    lbl_error_check_role: "Error checking user roles",
    lbl_meting: "Meeting",
    lbl_room_code_is_disabled: "Room code is disabled",
    lbl_room_code_does_not_exist: "Room code does not exist",
    lbl_endpoint_is_not_reachable: "Endpoint is not reachable",
    lbl_room_does_not_exist: "Room does not exist",
    lbl_accessing_disabled: "Accessing room using this link format is disabled",
    lbl_error_fetching_token: "Error fetching token",
    fm_toggle_interpretation: "Choose to listen to interpretation",
    lbl_other_options: "Another option",
    lbl_setting: "Setting",
    lbl_you: "You",
    lbl_have_a_nice_day: "Have a nice day",
    msg_you_left: "You left the {{type}}",
    lbl_left_by_mistake: "Left by mistake?",
    btn_rejoin: "Rejoin",
    msg_back_to_home: "Back to home",
    lbl_join_again: "You want to join again",
    lbl_click_here: "Click here",
    lbl_stream: "stream",
    lbl_room: "room",
    lbl_rename: "Rename",
    lbl_change_role: "Change role",
    lbl_change_my_role: "Change my role",
    lbl_mute_all: "Mute all",
    lbl_exit: "Exit",
    lbl_leave_room: "Leave Room",
    lbl_leave_studio: "Leave Studio",
    lbl_end_room: "End Room",
    lbl_end_room_for_all: "End Room for All",
    lbl_disable_future_joins: "Disable future joins",
    msg_end_room_warning: "Warning: You can’t undo this action",
    msg_can_rejoin_later: "You can always rejoin later",
    lbl_url_embed: "URL embed",
    lbl_cancel: "Cancel",
    lbl_change: "Change",
    lbl_update_embed: "Update embed",
    lbl_stop_embed: "Stop embed",
    lbl_embed_and_share: "Embed and share",
    lbl_change_multiple_role: "Change multiple role",
    lbl_select_role: "Select role",
    lbl_select_language: "Select language",
    preview: {
      room_protected: "Room is protected",
      enter_password: "Enter password",
      submit: "Submit",
      password_incorrect: "Incorrect password",
      get_started: "Get Started",
      setup_audio_before_joining: "Setup your audio and video before joining",
    },
    lbl_reload_page: "Reload page",
    lbl_reload: "Reload",
    lbl_copy_error_details: "Copy error details to clipboard",
    lbl_copy_details: "Copy Details",
    lbl_copied: "Copied",
    lbl_settings: "Settings",
    // Auto-added keys for i18n migration (ensure these exist)
    lbl_attention: "Attention",
    msg_hls_autoplay:
      'The browser wants us to get a confirmation for playing the HLS Stream. Please click "play stream" to proceed.',
    btn_play_stream: "Play stream",
    lbl_permission_error: "Permission Error",
    msg_autoplay_audio:
      "The browser wants us to get a confirmation for playing the Audio. Please allow audio to proceed.",
    btn_allow_audio: "Allow Audio",
    lbl_request_permission: "Request Permission",
    lbl_please_wait: "Please wait",
    msg_waiting_relax: "Sit back and relax till others let you join.",
    msg_reconnect_trying:
      "You lost your network connection. Trying to reconnect.",
    msg_sharing_screen: "You are sharing your screen",
    btn_stop_screen_share: "Stop screen share",
    msg_end_recording_warning:
      "Are you sure you want to end recording? You can’t undo this action.",
    btn_dont_end: "Don't end",
    btn_end_recording: "End recording",
    lbl_rtmp_url: "RTMP URL",
    ph_enter_rtmp_url: "Enter RTMP URL",
    lbl_stream_key: "Stream Key",
    ph_enter_stream_key: "Enter Stream Key",
    btn_end_stream: "End Stream",
    msg_waiting_for_stream: "Waiting for the stream to start...",
    btn_vote: "Vote",
    lbl_polls_quiz: "Polls/Quiz",
    msg_select_poll_type: "Select the type you want to continue with",
    lbl_hide_vote_count: "Hide Vote Count",
    lbl_make_results_anonymous: "Make Results Anonymous",
    btn_create_poll: "Create Poll",
    btn_create_quiz: "Create Quiz",
    lbl_previous_polls_quiz: "Previous Polls/Quiz",
    btn_view: "View",
    btn_add_another_question: "Add another question",
    btn_launch_quiz: "Launch Quiz",
    btn_launch_poll: "Launch Poll",
    ph_enter_your_answer: "Enter your answer",
    btn_skip: "Skip",
    lbl_skipped: "Skipped",
    lbl_submitted: "Submitted",
    lbl_voted: "Voted",
    btn_submit: "Submit",
    lbl_track_unmute_request: "Track Unmute Request",
    msg_track_unmute_body:
      "{{name}} has requested you to unmute your {{source}} {{type}}.",
    lbl_widgets: "Widgets",
    lbl_poll_quiz: "Poll/Quiz",
    msg_poll_quiz_subtitle: "Find out what others think",
    btn_share_music: "Share music",
    btn_stop_sharing_music: "Stop sharing music",
    msg_play_music_from: "Play music from Spotify or any other tab",
    msg_stop_playing_music: "Stop playing music from Spotify or any other tab",
    lbl_open_meeting_report: "Open meeting report",
    lbl_close_meeting_report: "Close meeting report",
    lbl_device_settings: "Device Settings",
    lbl_notifications: "Notifications",
    lbl_layout: "Layout",
    lbl_select_quality: "Select Quality",
    lbl_screenshare_audio: "Screenshare Audio",
    lbl_screenshare: "Screenshare",
    lbl_activate_presentation_slides: "Activate presentation slides",
    lbl_deactivate_presentation_slides: "Deactivate presentation slides",
    lbl_playlist_music: "Playlist Music",
    lbl_whiteboard: "Whiteboard",
    msg_playlist_is_playing: "Playlist is playing",
    msg_music_is_playing: "Music is playing",
    lbl_switch_camera: "Switch Camera",
    lbl_share: "Share",
    lbl_start_sharing: "Start Sharing",
    lbl_choose_what_to_share: "Choose what you want to share",
    msg_share_your_tab: "Share your tab, window or your entire screen",
    lbl_share_pdf: "Share PDF",
    msg_annotate_pdf: "Annotate, draw shapes, and more over PDFs",
    btn_go_back: "Go Back",
    btn_start_sharing: "Start Sharing",
    lbl_start_screen_sharing: "Start screen sharing",
    lbl_stop_screen_sharing: "Stop screen sharing",
    lbl_live: "LIVE",
    lbl_select_emoji: "Emoji reaction",
    lbl_reactions_timed_live_viewers:
      "Reactions will be timed for Live Streaming viewers.",
    lbl_learn_more: "Learn more",
    lbl_invalid_url: "Invalid URL!",
    tooltip_hide_sidebar: "Hide sidebar",
    tooltip_show_sidebar: "Show sidebar",
    lbl_need_help: "Need help?",
    lbl_browse: "Browse",
    lbl_audio_playlist: "Audio Playlist",
    lbl_video_playlist: "Video Playlist",
    lbl_audio_player: "Audio Player",
    lbl_start_streaming: "Start streaming",
    lbl_hls_starting: "HLS start in progress",
    lbl_rtmp_starting: "RTMP start in progress",
    lbl_go_live: "Go Live",
    lbl_link_copied: "Link copied!",
    lbl_copy_invite_link: "Copy Invite Link",
    lbl_hls_streaming: "HLS Streaming",
    lbl_hls_streaming_description:
      "Stream directly from the browser using any device with multiple hosts and real-time messaging, all within this platform.",
    lbl_invite_people: "Invite People",
    lbl_start_conversation: "Start the conversation",
    lbl_starting_stream: "Starting stream...",
    lbl_cannot_start_recording_once_stream_starts:
      "You cannot start recording once the stream starts, you will have to stop the stream to enable recording.",
    lbl_select_multiple_role: "Select multiple role",
    lbl_become_role: "Become role:",
    lbl_my_screen: "My screen",
    lbl_signal: "Poor signal",
    lbl_mute_mic: "You're muted",
    lbl_participants_1: "Participants",
    lbl_no_participants: "There are no participants",
    lbl_no_suitable_participants: "There are no suitable participants",
    lbl_search_participants: "Input search information",
    lbl_all: "All",
    lbl_change_permissions: "Change permissions",
    lbl_remove_participants: "Remove participants",
    lbl_change_role_of: "Change role of",
    lbl_become: "become",
    lbl_submit_request_confirm: "Send confirmation request",
    lbl_pin: "Pin",
    lbl_unpin: "Unpin",
    lbl_outstanding_position_for_everyone: "Outstanding position for everyone",
    lbl_removed_from_prominent_position: "Removed from prominent position",
    lbl_connected_now: "You are now connected",
    lbl_open_chat: "Open chat",
    lbl_welcome_joined: "Welcome, you've joined",
    lbl_person_first: "You are the first person to join the room",
    lbl_sit_down: "Please sit back and relax until others join",
    lbl_select_maximum_resolution: "Select maximum resolution",
    lbl_resolution_width: "Width",
    lbl_resolution_height: "Height",
    lbl_currently_streaming: "Currently streaming:",
    lbl_low: "Low",
    lbl_medium: "Medium",
    lbl_high: "High",
    lbl_sharing_screen: "You are sharing your screen",
    lbl_stop_share: "Stop sharing your screen",
    msg_error_check_role:
      "An error occurred while checking your role. Please double check your role or contact Circle's Seed for more details.",
    msg_room_code_is_disabled:
      "Room code corresponding to this link is no more active.",
    msg_room_code_does_not_exist:
      "We could not find a room code corresponding to this link.",
    msg_room_does_not_exist:
      "We could not find a room corresponding to this link.",
    msg_accessing_disabled:
      "You can re-enable this from the developer section in Dashboard.",
    msg_error_fetching_token:
      "An error occurred while fetching the app token. Please look into logs for more details.",
    msg_embed:
      "Embed the url and share with everyone in the room. Make sure you're sharing the current tab when the prompt opens. Note that not all websites support embedding.",
    fm_toggle_sound: "{{status}} mic ({{key}} + d)",
    fm_toggle_video: "{{status}} video ({{key}} + e)",
    fm_toggle_background: "{{status}} virtual background",
    fm_gird_layout_view: "Grid in view({{count}})",
    fm_toggle_pip: "{{status}} picture-in-picture mode",
    fm_interpretation_end:
      "{{text1}} translation has ended. You are redirected to listen to {{text2}}",
    fm_interpretation_select: "You have chosen to listen to {{text}}",
    fm_you_have_left_cabin: "You have left the epidemic room",
    fm_not_connect_room: "Can't connect to {{name}}",
    fm_endpoint_is_not_reachable: "Endpoint is not reachable. {{desc}}",
    fm_you_out_room: "You have left the room {{name}}",
    fm_fullscreen: "{{action}} fullscreen",
    fm_open_chat: "{{action}} chat",
    fm_you_content: "You ({{content}})",
    fm_toggle_fullscreen: "{{text}} fullscreen",
    fm_toggle_sharescreen: "{{text}} screen sharing",
    fm_volume: "Volume {{number}}",
    fm_pin_screen: "{{action}} frame",
    fm_block_permission: "Permission {{device}} has been blocked",
    fm_access_permission: "Access to {{device}} is required. ",
    fm_accept_permission_system:
      "Enable {{device}} permissions from the system",
    fm_accept_permission_browser:
      "Enable {{device}} permissions from the address bar or browser settings",
    fm_hands_up: "{{name}} hands up",
    fm_hands_up_multiple:
      "{{name}} and {{number}} other person raised their hands",
    fm_joined: "{{name}} joined",
    fm_left: "{{name}} left",
    fm_left_multiple: "{{name}} and {{number}} other person left",
    fm_new_message: "New message from {{name}}",
    fm_new_message_multiple: "{{number}} new message",
    fm_offline:
      "You are now online, while we try to reconnect, please check your internet connection. {{message}}",
    fm_reconnected: "You are now connected",
    fm_reconnecting:
      "You are offline for now. while we try to reconnect, please check your internet connection. {{message}}",
    fm_role_changed: "{{name}} is now {{role}}",
    fm_others_role_changed: "{{name}} and {{number}} others are now {{role}}",
    fm_others_joined: "{{name}} and {{number}} others joined",
    fm_others_left: "{{name}} and {{number}} others left",
    fm_raised_hand: "{{name}} raised hand",
    fm_others_raised_hand: "{{name}} and {{number}} others raised hand",
    fm_start: "Start",
    fm_stop: "Stop",
    lbl_no_msg: "No message",
    lbl_hands_up: "Hands up",
    lbl_hands_down: "Hands down",
    lbl_open: "Open",
    lbl_close: "Close",
    lbl_activate: "Activate",
    lbl_deactivate: "Deactivate",
    lbl_everyone: "Everyone",
    lbl_new_msgs: "New messages",
    lbl_find_participants: "Find participants",
    lbl_roles: "Roles",
    lbl_participant: "Participants",
    lbl_write_smt_here: "Write something here",
    lbl_toggle_all_remote_audio_devices: "Mute/Unmute remote audio devices",
    lbl_all_roles: "All roles",
    lbl_track_type: "Track type",
    lbl_track_source: "Track source",
    lbl_track_status: "Track status",
    lbl_mute: "Mute",
    lbl_unmute: "Request to unmute",
    lbl_apply: "Apply",
    lbl_all_sources: "All sources",
    lbl_all_devices: "All device types",
    lbl_strangers: "Stranger",
    lbl_pin_msg: "Pin message",
    lbl_more_options: "More options",
    lbl_toggle_widget_menu: "Toggle Widget Menu",
    lbl_change_name: "Change Name",
    lbl_bulk_role_change: "Bulk Role Change",
    lbl_fullscreen_enter: "Go Fullscreen",
    lbl_fullscreen_exit: "Exit Fullscreen",
    lbl_show_hls_stats: "Show HLS Stats",
    lbl_stats_for_nerds: "Stats for Nerds",
    lbl_show_stats_on_tiles: "Show Stats on Tiles",
    lbl_stats_for: "Stats For",
    ph_select_stats: "Select Stats",
    lbl_more: "More",
    lbl_copy: "Copy",
    lbl_copy_failed: "Copy failed",
    lbl_private: "PRIVATE",
    lbl_to: "To",
    fm_to_peer: "TO {{peer}}",
    fm_to_you: "TO YOU",
    lbl_no_messages_here: "There are no messages here",
    lbl_embed_url: "Embed URL",
    lbl_url: "URL",
    lbl_embed_url_help:
      "Embed a url and share with everyone in the room. Ensure that you're sharing the current tab when the prompt opens. Note that not all websites support being embedded.",
    lbl_raise_hand: "Raise hand",
    lbl_unraise_hand: "Unraise hand",
    lbl_im_back: "I'm back",
    lbl_ill_be_right_back: "I'll be right back",
    lbl_spotlight_remove: "Remove from Spotlight",
    lbl_spotlight_for_everyone: "Spotlight Tile for everyone",
    lbl_tile_for_myself: "Tile for myself",
    obj_roles: {
      lbl_presenter: "Presenter",
      lbl_host: "Host",
      lbl_broadcaster: "Speaker",
      lbl_panelist: "Panelist",
      lbl_translator: "Interpreter",
      "lbl_e-v": "English - Vietnamese",
      "lbl_f-v": "French - Vietnamese",
      lbl_vietnamese: "Vietnamese",
      lbl_guest: "Guest",
      "lbl_guest-advanced": "Guest (Advanced)",
      lbl_viewer: "Viewer",
      "lbl_hls-viewer": "Viewer",
    },
    lbl_waiting_for_the_live_stream_to_start:
      "Waiting for the livestream to start",
    lbl_live_streaming: "Live Streaming",
    lbl_sign_in: "Sign in",
    lbl_sign_in_desc: "Sign in to continue to your meeting",
    lbl_logout: "Logout",
    lbl_anonymous: "Guest",
    lbl_email: "Email",
    lbl_password: "Password",
    ph_email_example: "you@company.com",
    ph_password: "Your password",
    sign_in: {
      auto_failed: "Auto sign-in failed. Please sign in manually.",
      no_token: "Login failed: no token returned",
      wrong_password: "Incorrect email or password. Please try again.",
      login_failed: "Login failed",
    },
    lbl_keep_signed_in: "Keep me signed in",
    lbl_forgot_password: "Forgot password?",
    lbl_help: "Help",
    lbl_stream_management: "Manage Stream",
    lbl_stop_recording: "Stop Recording",
    lbl_are_you_sure_you_want_to_end_the_recording:
      "Are you sure you want to end the recording?",
    lbl_stop: "Stop",
    lbl_starting_recording: "Starting Recording",
    lbl_start_recording: "Start Recording",
    lbl_start: "Start",
    lbl_recording_already_running: "Recording already running",
    lbl_browser_message:
      'The browser wants us to get a confirmation for playing the Live HODO. Please click "play stream" to proceed.',
    err_sharing_embed: "Error while sharing embed url {{message}}",
    lbl_auto: "Auto",
    lbl_play: "Play",
    lbl_pause: "Pause",
    lbl_the_conference_will_start_in: "The conference will start in",
    lbl_the_conference_will_begin_soon:
      "The conference will begin soon. \nPlease sit down, rest and relax in the waiting time.",
    lbl_the_conference_has_ended:
      "The conference has ended, please come back at another time. \nThank you!",
    lbl_you_can_connect_with_others: "You cannot connect with others.",
    lbl_you_are_connected_but_no_one_is_active_in_the_circle:
      "You're connected but no one is active in the circle.",
    lbl_curentky_there_is_no_one_else_in_the_room:
      "Currently, there is no one else in the room.",
    lbl_this_role_does_not_exist: "This role does not exist.",
    lbl_this_role_has_not_been_published: "This role has not been published.",
    lbl_presentation_screen: "Presentation Screen",
    lbl_members: "Members",
    lbl_agenda: "Agenda",
    lbl_info: "Info",
    lbl_role_preside: "Preside",
    lbl_role_member: "Member",
    lbl_role_expert: "Expert",
    lbl_role_secretary: "Secretary",
    lbl_mdt: "MDT",
    lbl_meetings: "Meetings",
    lbl_search_rooms: "Search rooms by name",
    lbl_all_meeting_rooms: "All",
    lbl_one_time_meeting_room: "One-time",
    lbl_daily_meeting_room: "Daily",
    lbl_weekly_meeting_room: "Weekly",
    fm_pagination: "Showing {{countItems}} of {{totalItems}}",
    lbl_loading: "Loading...",
    lbl_prev: "Prev",
    lbl_next: "Next",
    lbl_report: "Reports",
    lbl_tqm: "FSMDT",
    lbl_tqm_short: "FSMDT",
    lbl_bbhc: "MDT",
    lbl_tttqm: "FSMDT",
    lbl_error_user_not_sign_in: "Error user not sign-in",
    msg_error_user_not_sign_in:
      "Please sign-in and join the meeting room through the {{domain}} connection portal",
    lbl_participants_meeting: "Meeting participants",
    lbl_save_meeting_minutes: "Save meeting minutes",
    lbl_update_meeting_minutes: "Update meeting minutes",
    lbl_doctor: "Doctor",
    lbl_patient: "Patient",
    lbl_checked_in: "Checked in",
    lbl_not_checked_in: "Not checked in",
    presentation: {
      menu: {
        bbhc: "MDT Meeting Report",
        tttqm: "Operation Summary",
        documents: "Laboratory testing/Paramedical exam",
        imaging: "Medical imaging",
      },
      actions: {
        approve: "Approve",
        cancel_approve: "Cancel Approve",
        pmdt_approve: "Approve",
        pmdt_deny: "Deny",
        pmdt_cancel: "Cancel",
        add: "Add",
      },
      labels: {
        approved: "Approved",
        pmdt_approved: "Approved",
        presenter: "Presenter",
        unknown: "Unknown",
        cases: "Cases: {{count}}",
      },
      fields: {
        admission_date: "Admission date:",
        diagnosis: "Diagnosis:",
        patient_name: "Patient name:",
        address: "Address:",
        dept: "Department:",
        summary: "Disease histories:",
        treatment_progress: "Disease progress / Treatment summary:",
        conclusion_note: "Conclusion (after review and discussion)",
        conclusion: "Conclusion:",
        treatment: "Decision:",
        preside: "Preside:",
        age: "Age:",
        gender: "Gender:",
        mdt_time: "MDT time:",
        secretary: "Secretary:",
        members: "Participants:",
        profile_code: "Profile code:",
        treatment_period: "Treatment period:",
        tests_section: "II. Tests",
        test_group_blood: "1. Blood tests",
        test_ure: "Ure",
        test_bilirubin_tp: "Bilirubin TP",
        test_hst: "HST",
        test_creatinin: "Creatinin",
        test_bilirubin_tt: "Bilirubin TT",
        test_hc: "HC",
        test_glucose: "Glucose",
        test_got: "GOT",
        test_hct: "HCT",
        test_blood: "Blood group",
        test_protit: "Protit",
        test_gpt: "GPT",
        test_tc: "TC",
        test_pt: "PT%",
        test_cholesterol: "Cholesterol",
        test_blood_basic: "Basic coagulation",
        test_quick: "Quick",
        test_ggt: "GGT",
        test_urine: "2. Urine",
        test_xray: "3. X-ray",
        test_electrocar: "4. Electrocardiogram",
        test_ultrasound: "5. Ultrasound",
        test_endoscopy: "6. Endoscopy",
        test_drug_reaction: "Test drug reaction",
        test_antibiotics: "2. Pre-op antibiotics",
        test_surgery_method: "3. Surgical method",
        test_anaesthetic_method: "Anaesthetic method",
        test_surgical_team: "5. Surgical team",
        test_anaesthetic_team: "6. Anaesthetic team",
        test_anatomic: "7. Anatomic",
        test_blood_plan: "8. Blood plan",
        surgery_date: "Estimated surgery date",
        prognostic: "9. Prognostic",
        signatory_chief_anes: "Chief of Anaesthesia and Recovery",
        signatory_chief_surgery: "Head of Surgery",
        signatory_treating_doctor: "Treating Doctor",
        select_doctor: "Select doctor",
        preparation_section: "III. Patient preparation and treatment method",
      },
      errors: {
        approve_missing_bbhc:
          "MDT report is not approved yet, you can't approve this case",
        missing_conclusion_treatment:
          "Conclusion and Treatment are required to save MDT report, please update",
        missing_operation_summary:
          "Operation summary not approved yet, please add this report",
        no_bbhc: "No report available",
        no_tttqm: "No report available",
        no_document: "Document not found",
      },
      dialogs: {
        confirm_title: "Confirm",
        confirm_body: "Are you sure?",
        cancel: "Cancel",
        confirm: "Confirm",
        bbhc_title: "MDT Meeting Report",
        tttqm_title: "Operation Summary",
        signatory_section_title: "Signatories",
        save: "Save",
        print: "Print",
      },
      empty: "No Data",
      page: {
        title: "MDT Conference",
        date_label: "Date",
        participants_label: "Participants:",
        preside_label: "Preside:",
        approved_count: "Number of approved cases:",
        unapproved_count: "Number of unapproved cases:",
      },
      toast: {
        cant_change_language: "You can't change presentation language.",
        changed_language:
          "You have changed presentation language to {{language}}.",
        no_case_selected: "No case selected",
        no_case_data: "No case data to ask SuperDoc",
        superdoc_failed: "SuperDoc failed",
        saved_success: "Saved successfully",
      },
      superdoc: {
        failed_message: "SuperDoc failed. Please try again later.",
        fields: {
          summary_label: "Case summary",
          diagnosis_label: "Diagnosis",
          conclusion_label: "Conclusion",
          treatment_label: "Further treatment",
        },
      },
      patient_info:
        "{{name}} ({{gender}} - {{age}}) - Reference doctor : {{doctor}}",
      case_label: "Case {{number}}",
    },
    common: {
      success: "Success",
    },
    superdoc_name: "SuperDoc",
    superdoc_greeting:
      "Hello! I'm SuperDoc. I support clinicians with treatment guidance and comprehensive patient care.",
    superdoc_loading: "SuperDoc is processing...",
    superdoc_empty_message: "Please enter your question",
    signature: {
      select: "Select signature",
      loading: "Loading...",
      no_signatures: "No signatures found",
      create: "Create signature",
      provider_by: "Provided by:",
      signed_on: "Signed on:",
      status: "Status:",
      not_signed: "Not signed",
      warn_select_and_place:
        "Please choose a signature and place it on the document.",
      warn_select: "Please choose a signature.",
      alert_title: "Notice",
      err_cannot_load_document: "Unable to load document.",
      err_failed_load_signatures: "Failed to load signatures.",
      err_upload_signed_file: "Failed to upload signed document.",
      err_update_envelope: "Failed to update document after signing.",
      err_intrust_wrong_pin: "Incorrect PIN. Please try again.",
      err_intrust_sign_failed: "Signing failed: {{message}}",
      err_already_signing: "A signing operation is already in progress.",
      err_missing_secretary: "Secretary information not found",
      err_missing_president: "Preside information not found",
      err_missing_treating_doctor: "Treating doctor information not found",
      loading_data: "Loading data...",
      loading_pdf: "Loading PDF...",
    },
    intrust: {
      login_title: "IntrustCA Login",
      username: "Username",
      password: "Password",
      auth_method: "Authentication method",
      auth_pin: "PIN",
      auth_mobile: "Mobile App",
      logging_in: "Logging in...",
      login: "Login",
      login_missing: "Please enter username and password",
      login_failed: "Login failed. Please check your credentials.",
      cert_title: "Select IntrustCA Certificate",
      loading_certs: "Loading certificates...",
      no_certs: "No certificates found.",
      reload: "Reload",
      pin_label: "PIN code",
      pin_placeholder: "Enter PIN code",
      sign: "Sign",
      key_label: "Key",
    },
  },
};

export default data;
